<template>
  <PublicLayout>
    <div class="container">
      <PageHero
        title="تصفّح العقارات"
        subtitle="ابحث وفلتر بين العقارات المتاحة في الكويت"
        :breadcrumbs="[{ label: 'الرئيسية', to: '/' }, { label: 'العقارات' }]"
      />

      <FilterBar
        v-model="filters"
        :result-count="filtered.length"
        @clear="clearFilters"
      />

      <div v-if="filtered.length" class="property-grid">
        <PropertyCard
          v-for="property in filtered"
          :key="property.id"
          :property="property"
        />
      </div>

      <div v-else class="empty-state card">
        <h3>لا توجد نتائج</h3>
        <p class="muted">جرّب تغيير معايير البحث أو مسح الفلاتر.</p>
        <button type="button" class="btn btn-primary" @click="clearFilters">
          مسح الفلاتر
        </button>
      </div>
    </div>
  </PublicLayout>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import PublicLayout from "@/components/layout/PublicLayout.vue";
import PageHero from "@/components/mkdf/PageHero.vue";
import PropertyCard from "@/components/mkdf/PropertyCard.vue";
import FilterBar from "@/components/mkdf/FilterBar.vue";
import { properties } from "@/data/properties";

const route = useRoute();

const defaultFilters = () => ({
  type: "",
  category: "",
  area: "",
  search: "",
  priceMin: "",
  priceMax: "",
});

const filters = ref(defaultFilters());

watch(
  () => route.query.area,
  (area) => {
    if (area) filters.value.area = String(area);
  },
  { immediate: true }
);

const filtered = computed(() => {
  return properties.filter((p) => {
    const f = filters.value;
    if (f.type && p.type !== f.type) return false;
    if (f.category && p.category !== f.category) return false;
    if (f.area && p.areaSlug !== f.area) return false;
    if (f.priceMin && p.price < Number(f.priceMin)) return false;
    if (f.priceMax && p.price > Number(f.priceMax)) return false;
    if (f.search) {
      const q = f.search.toLowerCase();
      const haystack = `${p.title} ${p.location} ${p.ref}`.toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  });
});

function clearFilters() {
  filters.value = defaultFilters();
}
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: 48px 24px;
  max-width: 480px;
  margin-inline: auto;
}

.empty-state h3 {
  margin-bottom: 8px;
}

.empty-state p {
  margin-bottom: 24px;
}
</style>
